
import {SaleHistory, SaleHistoryEventType} from "@/models/base";
import {AuthService, DossierService} from "@/services";
import Vue from "vue";
import {formatDistanceToNow, isSameDate} from "@/utils/date-utils";
import {printLocalDateTime} from "@/utils/pretty-print";

export default Vue.extend({
	props: {
		event: {
			type: Object as ()=>SaleHistory,
			required: true
		}
	},
	computed: {
		hidden():boolean{
			if (AuthService.wfDossier.settings.HideSaleModifiedHistoryEvent){
				if (this.event.EventTypeID == SaleHistoryEventType.Edit || this.event.EventTypeID == SaleHistoryEventType.SaleTypeChanged){
					return true;
				}
			}
			return false;
		},
		dateString():string{
			if (isSameDate(this.event.TimeStamp, new Date())){
				return formatDistanceToNow(this.event.TimeStamp);
			}
			return printLocalDateTime(this.event.TimeStamp);
		},
		userName():string{
			if (this.event.UserID == 0) return "";
			let name = DossierService.getUser(this.event.UserID).getShortDisplayName();
			if (!name) return "";
			return this.$ct("by-user", {user: name}).toString();
		},
	},
	methods: {
		openExtraInfo(){
			this.$emit("open-info");
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
});
